<p-tabView *ngIf="attachment.guid == null || attachment.mimetype == 'text/html' && attachment.id != null">
    <div class="p-field" *ngIf="attachment.entity_id != 8">
        <label for="attachmentType">Tipo de Adjunto</label>
        <p-dropdown name="attachmentType" [options]="attachmentsTypes" optionValue="id" placeholder="Selecciona un tipo"
            [showClear]="true" appendTo="body" optionLabel="name" [(ngModel)]="attachment.attachment_type_id">
        </p-dropdown>
    </div>

    <p-tabPanel header="Adjuntos" *ngIf="attachment.mimetype != 'text/html' && !hideTabs">
        <p-fileUpload name="myfile[]" url="/api/attachments/upload" (onError)="onErrorUpload($event)"
            (onUpload)="onBasicUpload($event)" multiple="multiple"></p-fileUpload>
    </p-tabPanel>
    <p-tabPanel header="Combinar plantilla" *ngIf="attachment.entity_id != 12 && attachment.entity_id != 8">
        <div class="p-field" *ngIf="attachment.id == null">
            <label for="template">Plantilla</label>
            <p-dropdown name="template" [options]="templates" optionValue="id" placeholder="Selecciona plantilla" [showClear]="true"
                appendTo="body" optionLabel="name" [(ngModel)]="selectedTemplateHtml" (change)="loadHtml()"
                (onChange)="loadHtml()"></p-dropdown>
        </div>
        <div class="p-field">
            <label for="description">Descripción</label>
            <input name="description" type="text" pInputText [(ngModel)]="attachment.description" required/>
        </div>
        <editor apiKey="dve1lwso187it38lpq8gfhgoupl6h8kxe0zwpymefrnkyhdl" [ngModelOptions]="{standalone: true}"
            [(ngModel)]="html" [init]="tinyMceConfig" *ngIf="showTinyMCE" plugins="link media image fullscreen code"></editor>
        <button pButton class="p-button-danger p-mt-3" icon="pi pi-file-pdf" label="Guardar como nuevo" (click)="toDraft(true)" *ngIf="attachment.id"></button>
        <button pButton class="p-ml-2 p-mt-3" style="float: right;" icon="pi pi-check" label="Guardar" (click)="toDraft(false)"></button>
    </p-tabPanel>
</p-tabView>


<app-view #view [code]="'attachments.edit'" [model]="attachment" (onEvent)="onEvent($event)"
    *ngIf="attachment.guid != null && attachment.mimetype != 'text/html' || attachment.guid!=null && attachment.id != null && attachment.mimetype != 'text/html' || attachment.mimetype == 'text/html' && attachment.id == null"></app-view>
